interface Config {
  wsUrl: string
}

const local: Config = {
  wsUrl: 'http://localhost:3000'
}

const develop: Config = {
  wsUrl: 'https://yobora-service-dev.herokuapp.com'
}

const prod: Config = {
  wsUrl: 'https://yobora-manager-service.herokuapp.com'
}

const config =
  process.env.REACT_APP_STAGE === 'production' ? prod : process.env.REACT_APP_STAGE === 'develop' ? develop : local

export default {
  ...config
}



// WEBPACK FOOTER //
// ./src/config.ts